export default "__VITE_PUBLIC_ASSET__317341e4__"